import React from 'react'
import Statistics from '../../components/Statistics'
import { Helmet } from 'react-helmet'
import { Box, ImageList, ImageListItem, ImageListItemBar, ListSubheader } from '@mui/material'

const StatisticsPage = () => {
  return (
    <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>  آمار | جان اسنک </title>
        </Helmet>
      <Box sx={{position:'relative',width:'100%'}}>
        <img src="/images/000.png" alt=""  />
        <Box position={"absolute"} bgcolor={"#000"} width={"30%"} height={"100%"}>

        </Box>
      </Box>
        
    </>
  )
}

export default StatisticsPage
